import {
    EffectCoverflow, Autoplay, Lazy,
} from 'swiper';

export const providerSwiperConfig = {
    modules: [EffectCoverflow, Autoplay, Lazy],
    className: 'provider',
    slidesPerView: 'auto',
    spaceBetween: 0,
    loop: true,
    autoplay: {
        delay: 5000,
    },
    navigation: {
        nextEl: '.provider__swiper-button-prev',
        prevEl: '.provider__swiper-button-next',
    },
};
